import React, { Component } from "react";
import firebase from "firebase";
import "./style.scss";

class SelectFriends extends Component {
  state = {
    result: [],
  };

  handleInputChange = (e) => {
    const db = firebase.firestore();
    if (!e.target.value) this.setState({ result: [] });
    else {
      db.collection("users")
        .where("name", ">=", e.target.value)
        .where("name", "<", e.target.value + "z")
        .limit(5)
        .get()
        .then((querySnapshot) => {
          this.setState({ result: [] });
          querySnapshot.forEach((doc) => {
            this.setState({
              result: [
                ...this.state.result,
                {
                  name: doc.data().name,
                  photo: doc.data().photo,
                },
              ],
            });
          });
        });
    }
  };

  render() {
    return (
      <div className="challenge_select">
        <img
          alt="logo"
          className="challenge_select-logo"
          src={require("../../../assets/images/logo.svg")}
        ></img>
        <div className="challenge_select-header">
          Select 1 - 3 Facebook friends.
        </div>
        <div className="challenge_select-body">
          <div className="challenge_select-body-guide">
            Start typing their Facebook names and click
            <br />
            them to add them to selection.
          </div>
          <div className="challenge_select-body-selector">
            <input
              className="challenge_select-body-selector-input"
              placeholder="Input Name"
              onChange={this.handleInputChange}
            ></input>
            <div className="challenge_select-body-selector-result">
              {this.state.result
                ? this.state.result.map((item) => {
                    return (
                      <div className="challenge_select-body-selector-result-user">
                        <img alt="avatar" src={item.photo}></img>
                        <div>{item.name}</div>
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="challenge_select-body-comment">
            We display here max 5 results.. <br />
            so they will have to specify name almost all
          </div>
        </div>
        <button className="challenge_select-footer">CHALLENGE FRIENDS</button>
      </div>
    );
  }
}

export default SelectFriends;
